import React from 'react';

import { container, text, error, disabled, large } from './input-label.module.scss';

import Tooltip from './tooltip';
import Markdown from '../hoc/markdown';

type TInputLabelSize = 'normal' | 'large';

export interface IInputLabelProps {
    className?: string;
    id?: string;
    htmlFor?: string;
    children?: React.ReactNode;
    hint?: React.ReactNode;
    as?: 'label' | 'p' | 'markdown';
    isDisabled?: boolean;
    isError?: boolean;
    size?: TInputLabelSize;
}

const InputLabel: React.FC<IInputLabelProps> = ({
    className = '',
    id,
    htmlFor,
    hint,
    as = 'label',
    isDisabled,
    isError,
    size = 'normal',
    children,
}) => {
    const sizeClass = sizeClasses[size];

    return (
        <div
            className={`${container} ${className} ${isDisabled ? disabled : ''} ${
                isError ? error : ''
            } ${sizeClass} label`}
        >
            {as === 'label' && (
                <label htmlFor={htmlFor} className={text} id={id}>
                    {children}
                </label>
            )}
            {as === 'p' && (
                <p className={text} id={id}>
                    {children}
                </p>
            )}
            {as === 'markdown' && typeof children === 'string' && (
                <Markdown className={text}>
                    {children}
                </Markdown>
            )}
            {hint && <Tooltip>{hint}</Tooltip>}
        </div>
    );
};

const sizeClasses: Record<TInputLabelSize, string> = {
    normal: '',
    large: large,
};

export default InputLabel;
